module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/purchase/purchase.component.html
// module id = ./src/app/Pages/purchase/purchase.component.html
// module chunks = main